/*$('.news-slider.news-slider--desktop-mode').flickity({
    autoPlay: 3200,
    pauseAutoPlayOnHover: true,
    cellSelector: '.news-slider__slide',
    cellAlign: 'left',
    prevNextButtons: true,
    pageDots: true,
    wrapAround: true
});


$('.news-slider.news-slider--handheld-mode').flickity({
    autoPlay: 3200,
    pauseAutoPlayOnHover: true,
    cellSelector: '.news-slider__slide',
    cellAlign: 'center',
    prevNextButtons: true,
    pageDots: true,
    wrapAround: true
}); */

var mySwiper = new Swiper ('.swiper-news', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    speed: 400,
    spaceBetween: 40,
    slidesPerView: 3.5,
    wrapAround: false,
    breakpoints: {
        // when window width is >= 320px
        100: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        320: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
          spaceBetween: 40
        },
        750: {
            slidesPerView: 2,
        },
        751: {
            slidesPerView: 3.5,
        }
      },
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
    // Navigation arrows
    navigation: {
        nextEl: '.button-next-news',
        prevEl: '.button-prev-news',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.scrollbar-news',
        draggable: true,
    },
})

